import React from "react";
import Tippy from "@tippyjs/react";
import { ICON_TYPES } from "../../utils/constants";

const InformationTooltip = ({
    message,
    type = "info",
    className = "",
    appendTo = null,
}) => {
    const appendToSelector = appendTo
        ? () => document.querySelector(appendTo)
        : document.body;
    return (
        <>
            <Tippy
                content={message}
                placement="bottom"
                animation="scale"
                appendTo={appendToSelector}
            >
                <i
                    className={`fas fa-${ICON_TYPES[type]} ${type} ${className}`}
                />
            </Tippy>
        </>
    );
};

export default InformationTooltip;
